/**
 * Local calendar-day helpers.
 *
 * `Date.prototype.toISOString()` always renders in UTC, so
 * `new Date().toISOString().split('T')[0]` gives "today" in UTC rather than
 * the browser's local timezone — near midnight this silently lands on the
 * wrong calendar day for any timezone that isn't UTC itself. Use
 * localDateString() wherever a Date needs to become a YYYY-MM-DD string
 * meant to represent the *local* day (defaults to today's own local date).
 */
export function localDateString(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
